/**
 * Chrome Overlay Atoms -- Jotai state for global chrome overlays.
 *
 * Bug-report and contextual Help are GLOBAL actions, not module tools, so
 * they no longer live in the right-hand Toolbox (which is module-tools-only
 * and hidden on the dashboard). They open as modal overlays triggered from
 * the always-visible ActivityBar (and the website HeaderBar). This atom is
 * the single source of truth for which overlay, if any, is open.
 */

import { atom } from 'jotai'

/** Which global chrome overlay is open, if any. */
export const CHROME_OVERLAYS = ['bug-report', 'help'] as const
export type ChromeOverlay = (typeof CHROME_OVERLAYS)[number]

/** Active chrome overlay (`null` = nothing open). */
export const chromeOverlayAtom = atom<ChromeOverlay | null>(null)
